module.exports = __webpack_public_path__ + "static/media/skill_react.49fc877d.png";